import { useState } from "react";
import { useTranslation } from "react-i18next";
import { VossProductGroupType } from "../../../../Constants/VOSS/vossProductGroupType";

export function VossTierSelector({tiers, onSelect}) {
    const sortedTiers = [...tiers].sort((a, b) => a.rank - b.rank);

    return (
        <div className='d-flex flex-wrap justify-content-center align-items-start gap-24'>
            {sortedTiers.map((tier) => (
                <TierCard
                    key={tier.id}
                    tier={tier}
                    onSelect={onSelect}
                />
            ))}
        </div>
    );
};

function TierCard({ tier, onSelect }) {
    const { t } = useTranslation();
    const [isExpanded, setIsExpanded] = useState(false);

    let includedProductGroups = tier.productGroups.filter(x => x.productGroupType == VossProductGroupType.Included);
    let optionalProductGroups = tier.productGroups.filter(x => x.productGroupType != VossProductGroupType.Included);

    const displayedOptionalProductGroups = isExpanded ? optionalProductGroups : optionalProductGroups.slice(0, 2);
    const hiddenCount = optionalProductGroups.length - displayedOptionalProductGroups.length;
    const isLongTitle = tier.name?.length > 30;

    const toggleExpanded = () => setIsExpanded(prev => !prev);

    return <div className='card rounded-8 shadow-10 overflow-hidden col-md-3 p-0' style={{ minWidth: "320px" }}>
        <div className={"skynet-product-card-header p-16 text-center d-flex align-items-center justify-content-center"} style={{ minHeight: "100px" }}>
            <h1 className='mb-0 font-family-ubuntu-light' style={isLongTitle ? { fontSize: 'var(--font-size-lg)' } : undefined}>
                {tier.name}
            </h1>
        </div>
        <div className='d-flex flex-column px-24 pt-24 pb-16 justify-content-between' style={{ minHeight: "400px" }}>
            <div className='d-flex flex-column gap-24'>
                <div>
                    <p className='bg-default py-6 px-12 rounded-4 mb-12'>{t('vosstierselector.includes')}</p>
                    <div className='px-12 d-flex flex-column' style={{ gap: "12px" }}>
                        {includedProductGroups.map((includedProductGroup) => (
                            <p key={includedProductGroup.id} className='mb-0'>{includedProductGroup.name}</p>
                        ))}
                    </div>
                </div>
                {displayedOptionalProductGroups.length > 0 && <div>
                    <p className='bg-default py-6 px-12 rounded-4 mb-12'>{t('vosstierselector.optional')}</p>
                    <div className='px-12 d-flex flex-column' style={{ gap: "12px" }}>
                        {displayedOptionalProductGroups.map((optionalProductGroup) => (
                            <p key={optionalProductGroup.id} className='mb-0 border-bottom'>{optionalProductGroup.name}</p>
                        ))}
                        {optionalProductGroups.length > 2 &&
                            <button type="button" className='btn btn-link btn-sm p-0 mb-32' onClick={toggleExpanded}>
                                {isExpanded
                                    ? t('vosstierselector.showLess')
                                    : t('vosstierselector.showMore', { count: hiddenCount })}
                            </button>}
                    </div>
                </div>}
            </div>
            <div>
                <button className='btn btn-primary btn-sm w-100 mb-0' onClick={() => onSelect(tier.id)}>{t('vosstierselector.select')}</button>
            </div>
        </div>
    </div>
}
